import { useEffect, useState } from 'react';
import { SuppliesDivisionModel } from '../../../models/suppliesDivisionModel';
import axios from '../../../lib/axios';
import { DIVISION_CREATE } from '../../../lib/endpoints/category';

// ------------------------------------------------------------------------------------------------

interface Props {
  dataMasterDivision: SuppliesDivisionModel[];
  merchantId: string;
  mainGroupId: string;
  onRefetchData: any;
  onClose: VoidFunction;
}

const useFormDivisionController = ({
  dataMasterDivision,
  merchantId,
  mainGroupId,
  onRefetchData,
  onClose,
}: Props) => {
  // variables
  const [divisionValue, setDivisionValue] = useState<string>(null!);
  const [errorMessage, setErrorMessage] = useState<string>(null!);
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);
  const [loadingConfirmDialog, setLoadingConfirmDialog] = useState<boolean>(false);

  // functions
  const handleDivisionChange = (e: any) => {
    setDivisionValue(e.target.value);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleOpenConfirmDialog = () => {
    setOpenConfirmDialog(true);
  };


  const handleValidateForm = async () => {
    if (!divisionValue) {
      setErrorMessage('Please select division first');

      return false;
    }
    setErrorMessage('');
    return true;
  };

  const handleClickConfirmButton = () => {
    handleCreateData();
  };

  const handleCreateData = async () => {
    try {
      setLoadingConfirmDialog(true);
      const input = {
        main_group_name_id: mainGroupId,
        supplies_division_name_id: divisionValue,
        merchant_id: merchantId,
      };
      await axios.post(DIVISION_CREATE, input);
      await onRefetchData();
      onClose();
    } catch (err: any) {
      try {
        const getErrorMessage: string = err.response.data.message;
        setErrorMessage(getErrorMessage);
        console.log(err);
      } catch (err2) {
        setErrorMessage('Server error please try again');
      }
    } finally {
      setLoadingConfirmDialog(false);
      setOpenConfirmDialog(false);
    }
  };

  // useEffect
  useEffect(() => {
    if (dataMasterDivision?.length > 0) {
      setDivisionValue(dataMasterDivision[0]?.id);
    }
  }, [dataMasterDivision]);
  // return

  return {
    divisionValue,
    handleDivisionChange,
    errorMessage,
    openConfirmDialog,
    loadingConfirmDialog,
    handleCloseConfirmDialog,
    handleClickConfirmButton,
    handleOpenConfirmDialog,
    handleSetErrorMessage: (newValue: string) => setErrorMessage(newValue),
  };
};
export default useFormDivisionController;
